import React from "react";

interface FiconProps {
  image?: any;
  width?: number;
  className?: string;
  onClick?: any;
  children?: any;
}

export const FIcon = ({ image, className, width = 20, onClick, children }: FiconProps) => {
  return (
    <div className={`f-icon f-icon-color ${className} ${onClick ? "cursor-pointer" : ""}`} onClick={onClick}>
      {image ? <img src={image} alt="icon" width={width} /> : children}
    </div>
  );
};
